module.exports = __webpack_public_path__ + "feedbackmodule/img/logo_imi.32973cf6.png";